export interface NewsItem {
  id: string;
  cat: string;
  title: string;
  summary: string;
  cover: string;
  tags: string[];
  heat: number;
  reads: string;
  comments: number;
  time: string;
  readMin: number;
  isNew: boolean;
  hotLabel?: '爆' | '热' | '新' | '专';
  body: string[];
}

export const items: NewsItem[] = [
  {
    id: 'n01',
    cat: 'huati',
    title: '「信息断舍离」为什么成了年轻一代的新话题？',
    summary: '当算法把信息不断灌进手机，越来越多年轻人开始主动「做减法」：精简关注、清空订阅、给信息划分类别。这种情绪背后，是人们对注意力的重新掌控。',
    cover: 'https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20illustration%20of%20a%20clean%20decluttered%20desk%20with%20few%20neat%20papers%20and%20a%20closed%20box%20symbolizing%20less%20clutter%2C%20terracotta%20and%20cream%20tones%2C%20soft%20flat%20shapes%2C%20subtle%20grain%2C%20modern%20magazine%20style&width=640&height=400&seq=item-n01&orientation=landscape',
    tags: ['信息减负', '生活方式', '注意力'],
    heat: 9872,
    reads: '12.4万',
    comments: 386,
    time: '2小时前',
    readMin: 6,
    isNew: true,
    hotLabel: '爆',
    body: [
      '如果问最近年轻人最想逃离的是什么，「信息过载」一定榜上有名。关注列表越来越长，消息永远刷不完，连短视频都开始分不清是放松还是消耗。',
      '于是「断舍离」的概念从物品延伸到信息。有人清空冗余关注，有人把订阅按主题重新归类，也有人直接给手机设置专注模式。动作五花八门，内核却高度一致：夺回对注意力的支配权。',
      '这种「做减法」未必意味着彻底退网，而更像是一种主动的分类管理。把信息分门别类，该看的看、该弃的弃，让浏览从被动下滑变成主动检索。',
      '值得留意的是，这股风潮并非一时兴起。它背后是长期处于高刺激内容环境中的人群，开始重新评估「什么才值得被看见」。对创作者和平台而言，这同样是值得思考的信号。',
    ],
  },
  {
    id: 'n02',
    cat: 'huati',
    title: '「慢直播」悄悄回归，人们为什么又爱看了？',
    summary: '没有剧本、没有解说，只有一镜到底的海浪、森林或城市街景。被快节奏内容包围的人们，正在从「慢直播」里找回一种久违的松弛感。',
    cover: 'https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20illustration%20of%20a%20calm%20seascape%20with%20gentle%20waves%20and%20a%20small%20camera%20frame%2C%20soft%20cream%20and%20terracotta%20tones%2C%20flat%20relaxed%20composition%2C%20subtle%20grain%2C%20peaceful%20magazine%20style&width=640&height=400&seq=item-n02&orientation=landscape',
    tags: ['慢直播', '内容趋势', '松弛感'],
    heat: 7241,
    reads: '8.6万',
    comments: 204,
    time: '5小时前',
    readMin: 5,
    isNew: false,
    hotLabel: '热',
    body: [
      '在每秒都追求信息密度的当下，「慢直播」却悄悄回到人们的视野。镜头对准一片海、一条街、一座山，不剪辑、不配音，就这样一直播下去。',
      '有趣的是，这样的内容反而成了许多人的「背景音」和「电子壁纸」。有人把它挂在副屏当作陪伴，有人在评论区互相道一句晚安，直播间变成了一个微型的公共客厅。',
      '行业人士认为，「慢直播」的价值在于提供了低门槛的情绪出口。它不争夺你的注意力，只是安静地陪着，这在信息轰炸的语境里显得格外珍贵。',
      '当然，「慢直播」也不是完全没有商业想象空间。城市文旅、景区直播、助农带货都在尝试把这种「慢」转化为实打实的流量与口碑。',
    ],
  },
  {
    id: 'n03',
    cat: 'huati',
    title: '从「老钱风」到「静奢」，审美风向为何转向低调？',
    summary: '明艳撞色与夸张logo的潮流正在退潮，取而代之的是剪裁、面料与质感的较量。一场关于「松弛的体面」的审美讨论正在铺开。',
    cover: 'https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20illustration%20of%20a%20tailored%20neutral%20toned%20outfit%20on%20a%20hanger%20with%20fabric%20swatches%2C%20cream%20and%20soft%20brown%20palette%2C%20flat%20elegant%20shapes%2C%20subtle%20grain%2C%20sophisticated%20quiet%20luxury%20magazine%20style&width=640&height=400&seq=item-n03&orientation=landscape',
    tags: ['审美趋势', '静奢', '生活方式'],
    heat: 5630,
    reads: '6.1万',
    comments: 173,
    time: '8小时前',
    readMin: 4,
    isNew: false,
    body: [
      '过去几年，夸张的logo、高饱和的撞色一度是流行标配。而如今，越来越多讨论把镜头对准了「老钱风」「静奢」这些关键词。',
      '所谓「静奢」，核心是去掉显眼的标识，用剪裁、面料与比例说话。比起一眼能认出的品牌，它更在意的是整体呈现出来的质感与松弛。',
      '这一审美转向并非凭空出现。它呼应着人们对于「炫耀式消费」的疲劳，也折射出实用主义与长期主义在消费决策中权重上升。',
      '对普通消费者而言，与其追逐某个名词，不如把它理解为一种提醒：真正耐看的，往往是不那么喧哗的。',
    ],
  },
  {
    id: 'n04',
    cat: 'shijian',
    title: '一款笔记App登顶周榜，我们梳理了这场「社区起飞」始末',
    summary: '从工具型产品到内容社区，它的周榜登顶不是偶然。这场事件背后，是一次关于「轻社交」需求的精准承接。',
    cover: 'https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20illustration%20of%20a%20rising%20chart%20with%20app%20icon%20blocks%20and%20linked%20community%20nodes%2C%20rust%20and%20cream%20tones%2C%20flat%20soft%20shapes%2C%20subtle%20grain%2C%20clean%20data%20journalism%20magazine%20style&width=640&height=400&seq=item-n04&orientation=landscape',
    tags: ['行业事件', '内容社区', 'App'],
    heat: 11203,
    reads: '15.2万',
    comments: 421,
    time: '1小时前',
    readMin: 7,
    isNew: true,
    hotLabel: '爆',
    body: [
      '一款原本偏工具定位的笔记应用，最近一举登上应用商店效率类周榜前列。原因并不在产品本身，而在于它所承载的「轻社交」内容开始破圈。',
      '事件的开端是几个高质量的「模板合集」在平台上被反复转发，随后大量用户涌入分享自己的使用方式。工具社区与内容社区之间，第一次实现了顺畅的双向流动。',
      '在业内看来，这次起飞的关键在于「低门槛参与」。用户不需要额外下载社交软件，不必经营人设，只要分享一份实用的模板，就能获得真实的认同。',
      '当然，热度带来的也是新一轮治理考验：如何筛掉搬运与营销号、如何让优质内容持续浮现，都将在接下来数月内被反复验证。',
    ],
  },
  {
    id: 'n05',
    cat: 'shijian',
    title: '「凌晨三点的热搜」：一次普通加班引发的集体共鸣',
    summary: '一条关于深夜加班的普通发言意外冲上热搜，评论区涌入了上万条加班故事。它折射出的，是普遍的工作强度与休息焦虑。',
    cover: 'https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20illustration%20of%20a%20desk%20lamp%20glowing%20at%20night%20with%20moon%20and%20clock%20symbols%2C%20deep%20rust%20and%20cream%20tones%2C%20flat%20emotive%20shapes%2C%20subtle%20grain%2C%20calm%20nocturnal%20magazine%20style&width=640&height=400&seq=item-n05&orientation=landscape',
    tags: ['社会议题', '加班文化', '共鸣'],
    heat: 9430,
    reads: '13.1万',
    comments: 512,
    time: '3小时前',
    readMin: 6,
    isNew: false,
    hotLabel: '热',
    body: [
      '深夜时分，一条关于「又加班到这个点」的普通发言，意外登上了热搜。没有戏剧冲突，也没有对立情绪，却引来了上万条加班故事式的跟帖。',
      '评论区里，有人分享凌晨通勤的疲惫，有人讨论「下班自由」的含义，也有人给出缓解疲劳的小技巧。这场由一句抱怨引发的讨论，很快升级为对工作节奏的集体审视。',
      '舆论场上，观点并不全然一致：有人强调奋斗的价值，也有人主张「休息不是可耻的」。但几乎所有人都认可——高强度、无反馈的加班，正在透支人的长期状态。',
      '事件本身或许会很快过去，但它留下的讨论值得被记住：当越来越多普通人愿意公开说出「我需要休息」，改变的种子就已埋下。',
    ],
  },
  {
    id: 'n06',
    cat: 'shijian',
    title: '新上线「绿幕社区」首日被挤爆，背后发生了什么？',
    summary: '一个以「作品互评」为卖点的创作者社区，上线首日即因流量过大出现卡顿。热闹背后，是创作者对于真实反馈的长期渴求。',
    cover: 'https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20illustration%20of%20a%20lively%20forum%20with%20many%20small%20avatar%20icons%20and%20speech%20bubbles%20around%20a%20green%20screen%2C%20terracotta%20and%20cream%20palette%2C%20flat%20playful%20shapes%2C%20subtle%20grain%2C%20community%20magazine%20style&width=640&height=400&seq=item-n06&orientation=landscape',
    tags: ['创作者', '社区', '事件'],
    heat: 6680,
    reads: '7.3万',
    comments: 268,
    time: '11小时前',
    readMin: 5,
    isNew: false,
    body: [
      '主打「作品互评」的创作者社区「绿幕」在上线首日，就因注册用户激增导致服务器一度卡顿。运营方紧急扩容并致歉，热度却不降反升。',
      '细看这个社区的设计：它把「被看见」与「被认真评价」放在首位，鼓励陌生创作者之间给出结构化反馈，而非单纯点赞。',
      '首日挤爆的原因，或许正说明内容创作者长期被廉价反馈包围的痛点。一句走心的点评，比一万个机械的赞更能支撑一个人继续创作。',
      '可以预见，随着热度回落，真正的考验才刚开始：社区氛围如何维持、评价体系如何防止抱团与阴阳怪气，将决定它能否从「现象」走向「长跑」。',
    ],
  },
  {
    id: 'n07',
    cat: 'renwu',
    title: '「内容策展人」正成为一个被需要的新角色',
    summary: '在内容过剩的时代，筛选、归类与推荐本身成了一种稀缺能力。越来越多品牌与平台，开始为「策展型人才」买单。',
    cover: 'https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20illustration%20of%20a%20persona%20arranging%20a%20wall%20of%20cards%20and%20tags%20into%20neat%20categories%2C%20terracotta%20and%20cream%20tones%2C%20flat%20soft%20shapes%2C%20subtle%20grain%2C%20curator%20magazine%20style&width=640&height=400&seq=item-n07&orientation=landscape',
    tags: ['新职业', '内容行业', '人物'],
    heat: 5390,
    reads: '5.8万',
    comments: 142,
    time: '昨天',
    readMin: 4,
    isNew: false,
    hotLabel: '新',
    body: [
      '内容不是不够多，而是太少了？恰恰相反，如今稀缺的是「会挑内容的人」。一个叫「内容策展人」的新角色，正在被越来越多的团队需要。',
      '策展人的工作，并不只是转发与收藏。他们要对内容建立标准，判断什么值得被呈现，并像办展览一样把信息编排成有逻辑的叙事。',
      '对企业而言，好的策展人能替品牌沉淀内容资产、建立专业形象；对个人而言，这也成了一条把「审美与判断力」变现的路径。',
      '有观察者提醒：策展的核心是真诚的品味，而不是搬运的堆砌。缺乏独立判断的「伪策展」，很快就会被读者识破。',
    ],
  },
  {
    id: 'n08',
    cat: 'renwu',
    title: '把古籍做成播客的90后：一场「慢内容」的十年实验',
    summary: '当别人都在追逐快流量时，一位90后却坚持把古籍里的故事讲给年轻人听。十年过去，他的「慢内容」长出了意想不到的生命力。',
    cover: 'https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20illustration%20of%20an%20old%20book%20opening%20into%20sound%20waves%20and%20headphones%2C%20antique%20brown%20and%20cream%20tones%2C%20flat%20gentle%20shapes%2C%20subtle%20grain%2C%20heritage%20storytelling%20magazine%20style&width=640&height=400&seq=item-n08&orientation=landscape',
    tags: ['播客', '内容实验', '人物'],
    heat: 4810,
    reads: '4.9万',
    comments: 119,
    time: '2天前',
    readMin: 6,
    isNew: false,
    body: [
      '在快节奏的内容赛道上，阿澄（化名）选择了一条慢路：用音频讲述古籍里的故事，一讲就是十年。',
      '一开始，这类内容几乎没有流量。但阿澄坚持做一件事——不把古籍包装成「故纸堆」，而是讲成人人都能共鸣的处世智慧与悲欢离合。',
      '转折发生在近几年：随着对传统文化的关注升温，他的节目被越来越多年轻人翻出来收藏，「原来古人早就说过这句话」成为评论区高频弹幕。',
      '回看这场「慢内容」实验，阿澄觉得核心不是坚持，而是想清楚「为谁做、做什么」。慢不是迟钝，而是把力气用在对的地方。',
    ],
  },
  {
    id: 'n09',
    cat: 'jigou',
    title: '出版社转向订阅制一年后，交出了怎样的答卷？',
    summary: '当电子书与短视频争夺注意力，一家出版社尝试把「会员订阅」做成新主业。一年过去，数据背后有惊喜也有清醒。',
    cover: 'https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20illustration%20of%20a%20publishing%20house%20with%20books%20and%20a%20membership%20card%20badge%2C%20rust%20and%20cream%20tones%2C%20flat%20soft%20shapes%2C%20subtle%20grain%2C%20business%20magazine%20style&width=640&height=400&seq=item-n09&orientation=landscape',
    tags: ['机构观察', '订阅制', '出版'],
    heat: 5920,
    reads: '6.7万',
    comments: 156,
    time: '3天前',
    readMin: 5,
    isNew: false,
    body: [
      '一年前，「暮屿书社」宣布把重心转向会员订阅制，每月向订户寄送精心挑选的主题书单与导读。彼时，质疑声并不少。',
      '一年后的数据显示：订阅用户续订率稳定在七成以上，且订阅用户的人均阅读量明显高于普通用户。这让团队看到了「精选」的价值。',
      '但清醒也同样存在。订阅规模仍然有限，获客成本偏高，内容供应链需要持续投入。团队坦言，这是一门「慢生意」，急不得。',
      '在机构观察者看来，这桩实验真正的意义，是证明在信息碎片化的时代，「有人帮你挑选好书」这件事依然有付费意愿。',
    ],
  },
  {
    id: 'n10',
    cat: 'jigou',
    title: '内容平台如何治理谣言？三家机构的做法值得对照',
    summary: '同一条不实信息，不同平台的处置节奏与方式并不相同。我们对照三家主流平台的做法，梳理出治理谣言的三条经验线。',
    cover: 'https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20illustration%20of%20a%20shield%20with%20a%20checkmark%20surrounded%20by%20platform%20logos%20and%20magnifying%20glass%2C%20terracotta%20and%20cream%20palette%2C%20flat%20clean%20shapes%2C%20subtle%20grain%2C%20trust%20and%20safety%20magazine%20style&width=640&height=400&seq=item-n10&orientation=landscape',
    tags: ['治理观察', '平台', '辟谣'],
    heat: 5160,
    reads: '5.5万',
    comments: 188,
    time: '4天前',
    readMin: 6,
    isNew: false,
    body: [
      '当一则不实信息在多个平台同时发酵，处置的及时性往往决定扩散的半径。近期，我们对照了三家主流内容平台的辟谣动作。',
      '第一条经验是「速度与提示并重」：第一时间为争议内容打上待核实标识，比单纯删帖更能避免次生传播。',
      '第二条是「信源锚定」：以权威信源和原始出处为准绳，把用户的注意力引导回事实本身，而不是情绪。',
      '第三条则是「正向供给」：治理谣言不能只堵不疏，持续生产清晰、可信、可核验的内容，才是釜底抽薪的办法。',
    ],
  },
];

export const getItem = (id: string): NewsItem | undefined =>
  items.find((i) => i.id === id);

export const byCat = (slug: string): NewsItem[] =>
  items.filter((i) => i.cat === slug);

export const byCatCount = (slug: string): number =>
  items.filter((i) => i.cat === slug).length;

export const sortedByHeat = (): NewsItem[] =>
  [...items].sort((a, b) => b.heat - a.heat);